const comments = [
  {
    name: '光影行者',
    text: '自从发现八戒电影网，就再也没去过其他站。不缓冲不卡顿真的不是吹的，而且全程没有广告打扰，看片体验太舒服了。片库更新也快，院线刚下线的片子这里很快就能看到高清版。',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20profile%20avatar%20with%20warm%20golden%20circle%20on%20dark%20background%2C%20simple%20geometric%20style%2C%20no%20face%2C%20no%20text&width=120&height=120&seq=avatar-01&orientation=squarish',
  },
  {
    name: '周末影迷',
    text: '作为重度电影爱好者，我试过很多观影平台，八戒电影网的加载速度确实是最快的。1080P画质清晰，移动端体验也很棒，通勤路上追剧毫无压力。推荐给了好几个朋友，都说好用。',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20profile%20avatar%20with%20crimson%20red%20circle%20on%20dark%20background%2C%20simple%20geometric%20style%2C%20no%20face%2C%20no%20text&width=120&height=120&seq=avatar-02&orientation=squarish',
  },
  {
    name: '深夜放映室',
    text: '片库真的全！很多冷门文艺片和纪录片在其他地方都找不到，八戒这里居然都有高清资源。无广告这一点我必须给满分，观影过程中完全不会被打断情绪，沉浸感极强。希望一直保持这样的品质。',
    time: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20profile%20avatar%20with%20warm%20orange%20circle%20on%20dark%20background%2C%20simple%20geometric%20style%2C%20no%20face%2C%20no%20text&width=120&height=120&seq=avatar-03&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">观众之声</h2>
          <p className="text-foreground-500 text-sm mt-2">来自真实用户的观影体验分享</p>
        </div>
        <div className="space-y-4">
          {comments.map((item) => (
            <div
              key={item.name}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/60"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-sm font-semibold text-foreground-200">{item.name}</span>
                      <div className="flex items-center text-primary-400 text-xs">
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                        <i className="ri-star-fill"></i>
                      </div>
                    </div>
                    <span className="text-foreground-600 text-xs">{item.time}</span>
                  </div>
                  <p className="mt-2 text-foreground-500 text-sm leading-relaxed">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}